import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ithacaConfig } from "./data";

export default function IthacaPage() {
  return <CityPageTemplate config={ithacaConfig} />;
}